<template>
  <div id="Custom-Form">
    <div class="header">
      <i class="el-icon-arrow-left" @click="handleBack"></i>
      <span class="page-title">新增模板</span>
      <div>
        <el-button type="primary" size="small" @click="handleSave">保存</el-button>
        <el-button type="success" size="small" @click="handlePush">发布</el-button>
      </div>
    </div>
    <div class="main-contain">
      <div class="control-wrap">
        <el-button
          type="primary"
          style="width: 90%;margin-bottom: 10px;"
          @click="addCloumn"
        >
          新增分栏
        </el-button>
        <div class="title">基础组件</div>
        <div class="control-list">
          <div
            class="list-item"
            v-for="(item, index) in control"
            :key="index"
            @click="addField(item)"
          >
            {{ item.fieldName }}
          </div>
        </div>
      </div>
      <div class="content-wrap">
        <!-- <template v-for="(field, idx) in formList">
          <FormField :key="idx" :item="field" @handleItem="handleItem" />
        </template> -->
        <FormField
          :formList.sync="formList"
          :cloumnName.sync="cloumnName"
          :cloumnIndex.sync="cloumnIndex"
          :flagList="flagList"
          @handleItem="handleItem"
          @deleteItem="deleteItem"
          @relevanceItem="relevanceItem"
          @editCloumn="editCloumn"
          @deleteCloumn="deleteCloumn"
        />
      </div>
      <div class="rule-wrap">
        <!-- <div class="title">当前分栏：{{ cloumnName }}</div> -->
        <div class="title">组件设置</div>
        <EditRule
          :curItem.sync="curItem"
          :key="curItem.flag"
          v-if="isShow"
        />
      </div>
    </div>
    <RelevanceDialog
      v-if="showDailog"
      @handleClose="handleClose"
      @handleConfirm="handleConfirm"
      :relevanceList="relevanceList"
      :relevance="relevance" 
    />
    <EditColumn
      v-if="showEdit"
      :title="cloumnName"
      @handleClose="showEdit = false"
      @handleConfirm="handleConfirmEdit"
    />
  </div>
</template>

<script>
import fieldList from "./control";
import FormField from "./FormField.vue"; // 表单预览
import EditRule from "./EditRule.vue"; // 规则设置
import RelevanceDialog from "./RelevanceDialog"; // 题目关联
import EditColumn from "./EditColumn"; // 修改分栏名
export default {
  name: "CustomForm",
  components: {
    FormField,
    EditRule,
    RelevanceDialog,
    EditColumn
  },
  data() {
    return {
      control: JSON.parse(JSON.stringify(fieldList)),
      formList: [
        {
          cloumnName: "默认分栏",
          list: []
        }
      ],
      curItem: {},
      showDailog: false,
      relevanceColIndex: "",
      relevanceIndex: "",
      relevance: {},
      showEdit: false,
      cloumnIndex: 0,
      cloumnName: "默认分栏"
    }
  },
  computed: {
    // 是否显示右侧规则设置
    isShow() {
      let isShow = false;
      const curItem = this.curItem;
      console.log(1111, curItem);
      this.formList.forEach(item => {
        const lists = item.list.filter(item => item.flag === curItem.flag);
        if (lists.length >= 1) {
          isShow = true;
        }
      })
      return isShow;
    },
    // 题目关联-只展示后续的单选、多选题目
    relevanceList() {
      const colIndex = this.relevanceColIndex;
      const relevanceIndex = this.relevanceIndex;
      const formList = this.formList[colIndex]["list"];
      const cutArr = formList.slice(0, relevanceIndex); // 只截取前面的表单
      const filterArr = cutArr.filter(item => item.fieldType >= 4 && item.fieldType <= 7) //只截取单选、多选
      return filterArr;
    },
    // 关联过的题目 flag
    flagList() {
      const formList = this.formList.map(item => item.list).flat();
      const flagList = formList.filter(item => item.refFieldFlag);
      return flagList.map(i => i.refFieldFlag);
    }
  },
  created() {
    console.log(fieldList);
  },
  methods: {
    // 删除分栏
    deleteCloumn(title, index) {
      if (this.formList.length === 1) {
        this.$notify.warning("最少保留一个分栏");
        return;
      }
      this.$confirm('删除分栏会同时删除归属的表单，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const cloumnName = this.cloumnName;
        const cloumnIndex = this.cloumnIndex;
        this.cloumnName = cloumnName === title ? "" : cloumnName;
        this.cloumnIndex = cloumnIndex === index ? "" : cloumnIndex;
        this.formList.splice(index, 1);
      }).catch(() => {
        // todo       
      });
    },
    // 确认修改分栏名 判断分栏名是否有重复
    handleConfirmEdit(title) {
      const isHave = this.formList.some(item => item.cloumnName === title);
      if (isHave) {
        this.$notify.warning("已有相同的分栏名");
        return;
      }
      const cloumnIndex = this.cloumnIndex;
      this.cloumnName = title;
      this.formList[cloumnIndex]["cloumnName"] = title;
      this.showEdit = false;
    },
    // 编辑分栏
    editCloumn(title, index, bool) {
      this.cloumnName = title;
      this.cloumnIndex = index;
      this.showEdit = bool;
    },
    // 新增分栏
    addCloumn() {
      const len = this.formList.length;
      const cloumnName = `默认分栏${len + 1}`;
      this.formList.push({
        cloumnName: cloumnName,
        list: []
      });
      this.cloumnName = cloumnName;
      this.cloumnIndex = len;
    },
    // 添加控件
    addField(field) {
      if (!this.cloumnName && !this.cloumnIndex) {
        this.$notify.warning("请先选择分栏");
        return;
      }
      const cloumnName = this.cloumnName;
      const formIndex = this.formList.findIndex(item => item.cloumnName === cloumnName);
      const len = this.formList[formIndex].list.length;
      const flag = new Date().getTime() + len; // 标识符 
      const item = JSON.parse(JSON.stringify(field));
      item["flag"] = flag;
      if (item.fieldType >= 4 && item.fieldType <= 7) {
        item.selectTypes.push("选项1", "选项2");
      }
      this.formList[formIndex].list.push(item);
    },
    // 编辑控件规则
    handleItem(colIndex, index) {
      //console.log(item);
      this.curItem = this.formList[colIndex]["list"][index];
      console.log(this.curItem);
    },
    // 删除控件
    deleteItem(colIndex, index) {
      const item = this.formList[colIndex]["list"][index];
      if (this.flagList.indexOf(item.flag) > -1) {
        this.$notify.warning("与其他题目产生关联不能删除");
        return;
      }
      this.formList[colIndex]["list"].splice(index, 1);
    },
    // 关闭弹窗
    handleClose() {
      this.showDailog = false;
    },
    // 题目关联
    relevanceItem(colIndex, index) {
      if (index === 0) {
        this.$notify.warning("第一题不能设置关联逻辑");
        return;
      }
      this.relevanceColIndex = colIndex,
      this.relevanceIndex = index;
      this.relevance = this.formList[colIndex]["list"][index];
      const relevanceList = this.relevanceList;
      if (!relevanceList.length) {
        this.$alert('提示：此题前面没有单选题跟多选题，无法设置关联逻辑', '提示', {
          confirmButtonText: '知道了'
        });
        return;
      }
      this.showDailog = true;
    },
    // 确认题目关联
    handleConfirm(datas) {
      console.log(datas);
      const colIndex = this.relevanceColIndex;
      const index = this.relevanceIndex;
      this.formList[colIndex]["list"][index]["refFieldFlag"] = datas.flag;
      this.formList[colIndex]["list"][index]["refRelation"] = "=";
      this.formList[colIndex]["list"][index]["refFieldValue"] = datas.value;
      this.formList[colIndex]["list"][index]["refText"] = "与上方题目存在关联";
      this.handleClose();
    },
    // 保存
    handleSave() {
      console.log(this.formList);
      this.$emit("handleSave");
    },
    // 发布
    handlePush() {
      console.log(this.formList);
      this.$emit("handlePush");
    },
    // 返回
    handleBack() {
      this.$emit("handleBack");
    }
  }
}
</script>

<style lang="less" scoped>
#Custom-Form {
  height: 100vh;
  min-width: 900px;
  background: #eee;
  .header {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    background-color: aliceblue;
    .page-title {
      flex: 1;
      text-align: center;
    }
  }
  .main-contain {
    display: flex;
    height: calc(100% - 60px);
    .title {
      margin-bottom: 10px;
    }
    .control-wrap {
      flex: 0 0 300px;
      background-color: #fff;
      padding: 15px 0 0 15px;
      .control-list {
        display: flex;
        flex-wrap: wrap;
        /* padding: 10px; */
        .list-item {
          flex: 0 0 120px;
          border: 1px solid #ccc;
          padding: 4px 8px;
          margin: 0 10px 10px 0;
          border-radius: 4px;
          cursor: pointer;
          text-align: center;
          &:hover {
            border: 1px solid #409eff;
          }
        }
      }
    }
    .content-wrap {
      flex: 1;
      margin: 0 10px;
      background-color: #fff;
      padding: 15px;
      overflow-y: auto;
    }
    .rule-wrap {
      flex: 0 0 400px;
      background-color: #fff;
      padding: 15px;
      overflow-y: auto;
    }
  }
}
</style>